var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TipsNews"},[_c('top-bar',{attrs:{"title":"收费标准","hasBack":""}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"title"},[_vm._v("测试标题1")]),_c('div',{staticClass:"detail"},[_vm._v(" 测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容测试内容 ")])])
}]

export { render, staticRenderFns }